<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="row">
        <div class="col-12 mb-4">
            <v-card>
                <v-card-title>
                    {{$t('devises.management')}}
                    <v-spacer></v-spacer>
                    <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Search"
                            single-line
                            hide-details
                    ></v-text-field>
                </v-card-title>
                <v-data-table
                        :headers="headers"
                        :items="devises"
                        :search="search"
                        sort-by="name"
                        class="elevation-0"
                        :loading="!devises" 
                        loading-text="Chargement en cours...">


                    <template v-slot:top>
                        <v-toolbar flat color="white">
                            <v-spacer></v-spacer>
                            <v-dialog v-model="dialog" max-width="500px">
                                <template v-slot:activator="{ on }">
                                    <v-btn @click="defaultDevise()" style="background: #29B3A6;color: #fff" class="mb-2" v-on="on">
                                        {{$t('devises.new')}}
                                    </v-btn>
                                </template>
                                <v-card>
                                    <v-card-title>
                                        <span class="headline">{{ formTitle }}</span>
                                    </v-card-title>

                                    <v-card-text>

                                        <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                                            <v-alert v-if="errors" dense outlined
                                                     :type="(errors.update_error)?'error':'success'">
                                                {{$t(errors.operation)}}
                                            </v-alert>

                                            <v-text-field v-if="submitting" color="primary" loading
                                                          disabled></v-text-field>
                                            <v-row>

                                                <v-col cols="12" sm="6" md="12">
                                                    <v-text-field :rules="nameRules" v-model="editedItem._name"
                                                                  :label="$t('devises.name')"></v-text-field>
                                                </v-col>

                                                <v-col cols="12" sm="6" md="12">
                                                    <v-text-field :rules="codenumRules" v-model="editedItem._cod_num"
                                                                  :label="$t('devises.cod_num')"></v-text-field>
                                                </v-col>

                                                <v-col cols="12" sm="6" md="12">
                                                    <v-text-field :rules="codealphaRules"
                                                                  v-model="editedItem._code_alpha"
                                                                  :label="$t('devises.code_alpha')"></v-text-field>
                                                </v-col>

                                            </v-row>
                                        </v-form>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn color="dark"  @click="close">{{$t('cancel')}}</v-btn>
                                        <v-btn color="primary" :disabled="!valid"  @click="save" >{{$t('save')}}</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                            <v-dialog v-model="dialogFlag" max-width="1000px">
                                <v-card>
                                    <v-card-title>
                                        <span class="headline">{{ $t('devises.setcountries') }}</span>
                                    </v-card-title>

                                    <v-card-text>

                                        <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                                            <v-alert v-if="errors" dense outlined
                                                     :type="(errors.update_error)?'error':'success'">
                                                {{$t(errors.operation)}}
                                            </v-alert>

                                            <v-text-field v-if="submitting" color="primary" loading
                                                          disabled></v-text-field>
                                            <v-row>

                                                <v-col v-for="n in countries" :key="n._id" cols="12" sm="6" md="2">
                                                    <v-card
                                                            @click="chooseItem(n)"
                                                            :id="n._id"
                                                            class="ma-3 pa-6 chooseAll"
                                                            outlined
                                                            tile
                                                            :style="getBackColor(n._id)"
                                                    >
                                                        <country-flag :country=" n._code " size='normal'/>
                                                        <div class="text-center">{{n._name}}</div>

                                                    </v-card>
                                                </v-col>

                                            </v-row>
                                        </v-form>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn color="dark"  @click="closeflag">{{$t('cancel')}}</v-btn>
                                        <v-btn color="primary"  @click="saveflag">{{$t('save')}}</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                            <v-dialog v-model="dialogLink" max-width="600px">
                                <v-card>
                                    <v-card-title>
                                        <span class="headline">{{ $t('devises.setexchange') }} {{editedItem._code_alpha}} {{ $t('devises.setexchangeto') }} : </span>
                                    </v-card-title>

                                    <v-card-text>


                                        <v-form ref="form" v-model="valid" :lazy-validation="lazy" id="formLink">
                                            <v-alert v-if="errors" dense outlined
                                                     :type="(errors.update_error)?'error':'success'">
                                                {{$t(errors.operation)}}
                                            </v-alert>

                                            <v-text-field v-if="submitting" color="primary" loading
                                                          disabled></v-text-field>
                                            <v-row>
                                                <v-col v-for="n in devises" :key="n._id" cols="12" sm="12" md="12">
                                                    <div  v-if="(editedItem._id != n._id)">


                                                    <v-row>
                                                        <v-col cols="12" sm="6" md="3" style="margin-top: 2%; font-weight: bold">
                                                            {{n._name}} ({{n._cod_num}})
                                                        </v-col>
                                                        <v-col  cols="12" sm="6" md="4">
                                                            <span class="col-12" style="color: #29B3A6; font-weight: bold">{{$t('devises.rate')}}</span>
                                                            <input type="hidden"  name="devises_id[]" :value="n._id" >
                                                            <input type="text" required min="1"   name="rate[]" :id="n._id + 'rate'"  class="form-control resetiput" :placeholder="$t('devises.rate')" />
                                                        </v-col>
                                                         <v-col cols="12" sm="6" md="4">
                                                             <span class="col-12" style="color: #29B3A6; font-weight: bold">{{$t('devises.markup_rate')}}</span>
                                                             <input type="text" required min="1" name="markup_rate[]" :id="n._id + 'markup_rate'"  class="form-control resetiput" :placeholder="$t('devises.markup_rate')" />
                                                         </v-col>

                                                    </v-row>
                                                    <v-divider></v-divider>
                                                    </div>
                                                </v-col>
                                                <span style="color: red" v-if="errors_rate!=null">{{errors_rate}}</span>

                                            </v-row>
                                        </v-form>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn color="dark" text @click="closeLink">{{$t('cancel')}}</v-btn>
                                        <v-btn color="primary" text @click="saveLink">{{$t('save')}}</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                            <v-dialog v-model="dialogExcel" max-width="600px">
                                <v-card>
                                    <v-card-title>
                                        <span class="headline">{{ $t('devises.setexchangeupload') }} {{editedItem._cod_num}}  : </span>
                                    </v-card-title>

                                    <v-card-text>

                                        <v-form ref="form" v-model="valid" :lazy-validation="lazy" style="padding-bottom: 2%;">


                                            <v-text-field v-if="submitting" color="primary" loading
                                                          disabled></v-text-field>

                                            <v-col cols="12" sm="12" md="12">

                                                <v-file-input label="Fichier excel" :placeholder="$t('devises.choosefile')"
                                                              v-model="editedItemExcel._file"
                                                              ref="myFile" @change="selectedFile"
                                                              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                                              id="input_file"></v-file-input>
                                            </v-col>

                                            <span style="color: red" v-if="errors_excel!=null">{{errors_excel}}</span>

                                        </v-form>

                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn color="dark"  @click="closeexcel">{{$t('cancel')}}</v-btn>
                                        <v-btn color="primary" :disabled="!validexcel"   @click="saveExcel">{{$t('save')}}</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>

                            <v-dialog v-model="dialogDownloadExcel" max-width="600px">
                                <v-card>
                                    <v-card-title>
                                        <span class="headline">{{ $t('devises.downloadExcel') }} {{editedItem._cod_num}}  : </span>
                                    </v-card-title>

                                    <v-card-text>

                                        <v-col col=12 class="text-center">
                                          <vue-excel-xlsx
                                             :data="dataExcelContent"
                                             :columns="columnsExcelTitle"
                                             :filename="filename"
                                             :sheetname="sheetname"
                                             >
                                             <div class="text-center" style="margin-top: 15%">
                                                <v-btn
                                                  rounded
                                                  color="primary"
                                                  dark

                                                >
                                                 <v-icon style="margin-right: 1%">mdi-file-download</v-icon>  {{$t("devises.downloadExcelText")}}
                                                </v-btn>
                                              </div>
                                          </vue-excel-xlsx>
                                        </v-col>

                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn color="blue darken-1" text @click="dialogDownloadExcel=false">{{$t('cancel')}}</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>


                        </v-toolbar>

                    </template>

                    <template v-slot:item.actions="{ item }">

                      <div style="text-align:  right">
                          <v-menu
                                  key="text1233090909"
                                  rounded="b-xl">
                              <template v-slot:activator="{ attrs, on }">

                                      <v-icon

                                      class="black--text "
                                      v-bind="attrs"
                                      v-on="on">mdi-dots-vertical</v-icon>

                              </template>
                                <v-list>
                                    <v-list-item
                                            v-for="(ite, index) in items"
                                            :key="ite"
                                            link
                                            @click="editItemAction(item,index)"
                                    >
                                        <v-list-item-icon>
                                            <v-icon color="#29B3A6">{{ite.avatar}}</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title  v-text="ite.title"></v-list-item-title>

                                        </v-list-item-content>


                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </div>
                    </template>
                    <template v-slot:no-data>
                        {{$t('no_data')}}
                    </template>
                </v-data-table>
            </v-card>
        </div>

    </div>

</template>

<script>
    /* eslint-disable */
    import {mapState} from "vuex";
    import * as Swal from "sweetalert2";
    import CountryFlag from 'vue-country-flag'

    export default {
        components: {
            CountryFlag
        },
        label: "Devises",
        data() {
            return {
                submitting: false,
                valid: true,
                validexcel: false,
                dialogDownloadExcel:false,
                lazy: false,
                errors:undefined,
                search: '',
                errors_rate: null,
                errors_excel: null,
                sheetname:'sheetname',
                filename:'filename',
                dialog: '',
                dialogFlag: '',
                dialogLink: '',
                dialogExcel: '',
                id: undefined,
                headers: [
                    {
                        text: 'Nom',
                        align: 'start',
                        sortable: true,
                        value: '_name',
                    },
                    {text: 'Code Numérique', value: '_cod_num'},
                    {text: 'Code Alpha', value: '_code_alpha'},
                    {text: '', value: 'actions', sortable: false},

                ],
                editedIndex: -1,
                chooseFlagDev: [],
                editedItem: {
                    _name: '',
                    _cod_num: '',
                    _cod_alpha: '',
                    _id: 0,
                    _created_at: 0,
                },
                editedItemExchange: {
                    _rate: '',
                    _markup_rate: '',
                    _devise_from_id: '',
                    _devise_to_id: '',
                    _id: 0,
                    _created_at: 0,
                },
                editedItemExcel: {
                    _file: '',
                    _id: 0,
                    _created_at: 0,
                },
                defaultItem: {
                    _name: '',
                    _cod_num: '',
                    _cod_alpha: '',
                    _id: 0,
                    _created_at: 0,
                },
                defaultItemExcel: {
                    _file: '',
                    _id: 0,
                    _created_at: 0,
                },
                nameRules: [
                    v => !!v || 'Nom requis',
                    // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                ],
                codenumRules: [
                    v => !!v || 'Code numérique requis',
                ],
                codealphaRules: [
                    v => !!v || 'Code alpha requis',
                ],
                items: [
                    { title: "Définir les pays concernés", avatar: 'mdi-flag' },
                    { title: "Taux d'échange", avatar: 'mdi-call-split' },
                    { title: "Mise à jour excel", avatar: 'mdi-file' },
                    { title: "Télécharger l'excel", avatar: 'mdi-download-circle' },
                    { title: "Modifier", avatar: 'mdi-pencil' },
                    { title: "Historique", avatar: 'mdi mdi-view-list' },
                    { title: "Supprimer", avatar: 'mdi-delete' }
                ],
                columnsExcelTitle : [
                    {
                        label: "monnaie_de_convertion_numero",
                        field: "monnaie_de_convertion_numero",
                    },
                    {
                        label: "nom_convertir_en",
                        field: "nom_convertir_en",
                    },
                    {
                        label: "numero_convertir_en",
                        field: "numero_convertir_en",
                    },
                    {
                        label: "taux",
                        field: "taux",
                    },
                    {
                        label: "taux_d_echange",
                        field: "taux_d_echange",
                    },
                ],
                dataExcelContent : [

                ],

            }
        }
        ,
        computed: {
            formTitle() {
                return this.editedIndex === -1 ? this.$t('devises.new') : this.$t('devises.update')
            }
            ,
            ...mapState('devises/', ['devises'])
            ,
            ...mapState('countries/', ['countries'])
            ,
            ...mapState('exchanges/', ['exchanges'])

        }
        ,
        mounted() {
            this.$store.dispatch('devises/getDevises').then(response => {
                window.console.log('devises', response)
            });
           this.loadCountries();
        }
        ,
        watch: {
            dialog(val) {
                val || this.close()
            }/*,
            dialogFlag(val) {
                val || this.closeflag()
            },
*/
        }
        ,
        methods: {
            defaulltDevise() {
                this.editedItem= Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            }
            ,
            loadCountries(){
                this.$store.dispatch('countries/getCountries').then(response => {
                    console.log('countries', response);
                });
            },
            editItem(item) {
                this.editedIndex = this.devises.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.dialog = true;
            },
            getBackColor(id){
                if (this.chooseFlagDev.includes(id)){
                    return "background-color: rgb(0 181 164 / 16%)!important;";
                } else {
                    return "";
                }
            },
            editItemAction(item,index) {
                switch (index){
                    case 0:
                        this.editItemFlag(item)
                        break;
                    case 1:
                        this.editItemLink(item)
                        break;
                    case 2:
                        this.editItemExcel(item)
                        break;
                    case 3:
                            this.downloadExcel(item)
                            break;
                    case 4:
                        this.editItem(item)
                        break;
                    case 5:
                        this.$router.push({ name: 'exchangehistoriques', params: { id: item._id } })
                        break;
                    case 6:
                        this.deleteItem(item)
                        break;

                }
            },

            downloadExcel(item){

              let data = new FormData();
              data.append("id", item._id);
              this.editedItem._cod_num = item._cod_num;
              this.editedItem._id = item._id;
              this.sheetname = item._cod_num;
              this.filename = item._name;


              this.$store.dispatch('exchanges/getExchanges',data).then(response => {
                  //console.log('exchanges', response);
                  let tabContent = [];
                let tab_devises = this.$store.state.devises.devises;
                let tab = response.data.exchanges;
                console.log("tab",tab);
                let t=0;

                for (let i = 0; i < tab_devises.length; i++) {
                    let existe = false;
                    let values = [];

                      if(tab_devises[i]._id !=item._id){

                        for (let j = 0; j < tab.length; j++) {
                            if(tab_devises[i]._id==tab[j]._devise_to_id)
                            {
                              existe = true;
                              values = tab[j];
                              break;
                            }
                        }

                        if(existe){
                            tabContent[t] = {
                                monnaie_de_convertion_numero: item._id,
                                nom_convertir_en: tab_devises[i]._name,
                                numero_convertir_en: tab_devises[i]._id,
                                taux:values._rate,
                                taux_d_echange:values._markup_rate
                            };
                            t++;
                        }else{
                          tabContent[t] = {
                              monnaie_de_convertion_numero: item._id,
                              nom_convertir_en: tab_devises[i]._name,
                              numero_convertir_en: tab_devises[i]._id,
                              taux:1,
                              taux_d_echange:1
                          };
                            t++;
                        }

                  }

                }
                  console.log("tabContent",tabContent);
                  this.dataExcelContent = tabContent;
                  this.dialogDownloadExcel = true;
              });

            },

            editItemLink(item) {
                console.log("item",item);
                this.errors_rate = null;
                let data = new FormData();
                data.append("id", item._id);
                this.editedItem._cod_num = item._cod_num;
                this.editedItem._id = item._id;
                this.editedItem._code_alpha = item._code_alpha;
                this.$store.dispatch('exchanges/getExchanges',data).then(response => {
                    console.log('exchanges', response);
                });

                this.$store.watch(
                    function (state) {
                        console.log(state.devises.devises) ;
                        let tab_devises = state.devises.devises;
                        let tab = state.exchanges.exchanges;
                        for (let j = 0; j < tab_devises.length; j++) {
                            $("#"+tab_devises[j]._id+"rate").attr("value",1);
                            $("#"+tab_devises[j]._id+"markup_rate").attr("value",1);
                        }
                        for (let i = 0; i < tab.length; i++) {
                            $("#"+tab[i]._devise_to_id+"rate").attr("value",tab[i]._rate);
                            $("#"+tab[i]._devise_to_id+"markup_rate").attr("value",tab[i]._markup_rate);
                        }
                    },
                    function () {
                        //do something on data change
                    },
                    {
                        deep: true //add this if u need to watch object properties change etc.
                    }
                );


                this.dialogLink = true;
            }
            , editItemFlag(item) {
                this.chooseFlagDev = [];
                this.editedIndex = this.devises.indexOf(item);
                this.editedItem = Object.assign({}, item);

                $(".chooseAll").css("background-color", "");
                for (let i = 0; i < item._countries.length; i++) {
                    $("#" + item._countries[i]).css("background-color", "#A1C4E8!important;");
                }
                this.chooseFlagDev = item._countries;
                console.log("item",item._countries);
                this.dialogFlag = true;

            }
            , editItemExcel(item) {
                this.validexcel = false;
                this.errors_excel = null;
                this.editedIndex = this.devises.indexOf(item);
                this.editedItemExcel = Object.assign({}, item);
                this.editedItem = Object.assign({}, item);
                this.dialogExcel = true;
            }
            ,
            chooseItem(item) {
                console.log(item);
                let size = this.chooseFlagDev.length;
                if (this.chooseFlagDev.includes(item._id)) {
                   // $("#" + item._id).css("background-color", "");
                    let tab;
                    tab = jQuery.grep(this.chooseFlagDev, function (value) {
                        return value != item._id;
                    });
                    this.chooseFlagDev = tab;
                } else {
                    this.chooseFlagDev[size] = item._id;
                   // $("#" + item._id).css("background-color", "red");
                }
                this.loadCountries();

                console.log(this.chooseFlagDev);

            }
            ,

            deleteItem(item) {
                const index = this.devises.indexOf(item);
                Swal.fire({
                    icon: 'warning',
                    timerProgressBar: false,
                    text: this.$t('delete_warning'),
                    confirmButtonText: "Supprimer",
                    cancelButtonText: "Annuler",
                    showCancelButton: true,
                    cancelButtonColor:"#CCC",
                    confirmButtonColor:"#29B3A6"
                }).then(result => {
                    if (result.value) {
                        this.$store.dispatch('devises/deleteDevise', item._id).then((result) => {
                            Swal.fire({
                                icon: 'success',
                                timer: 3000,
                                timerProgressBar: false,
                                text: this.$t(result.message),
                                position: 'top-end',
                                showConfirmButton: false
                            })
                        })
                    }
                })
            },
            close() {
                this.dialog = false;
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1
                });
                this.$refs.form.reset()
            },
            closeflag() {
                this.dialogFlag = false;
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1
                });
                this.$refs.form.reset()
            },closeexcel() {
                this.dialogExcel = false;
                this.$nextTick(() => {
                    this.editedItemExcel = Object.assign({}, this.defaultItemExcel);
                    this.editedIndex = -1
                });
                this.$refs.form.reset()
            },
            closeLink() {
                this.dialogLink = false;
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1
                });
                this.$refs.form.reset()
            },
            saveLink() {
                this.submitting = true;

                let tab_rate = [];
                let tab_markup_rate = [];
                let tab_devises_id = [];
                tab_rate = $('input[name="rate[]"]').map(function () {
                    return (this.value!="" ? parseFloat(this.value) : "1"); // $(this).val()
                }).get();

                tab_markup_rate = $('input[name="markup_rate[]"]').map(function () {
                    return (this.value!="" ? parseFloat(this.value) : "1"); // $(this).val()
                }).get();

                tab_devises_id = $('input[name="devises_id[]"]').map(function () {
                    return (this.value!="" ? this.value : "1"); // $(this).val()
                }).get();

                console.log("tab_markup_rate",tab_markup_rate);

                if (tab_markup_rate.includes(0))
                {
                    this.errors_rate = this.$t('devises.errors_rate2')
                }
                else{
                    if (tab_rate.includes(0))
                    {
                        this.errors_rate = this.$t('devises.errors_rate1')
                    }else{
                        console.log("tab_devises_id",tab_devises_id);
                        this.errors_rate = null;
                        let data = new FormData();
                        data.append("rate", JSON.stringify(tab_rate));
                        data.append("markup_rate", JSON.stringify(tab_markup_rate));
                        data.append("devise_from_id", this.editedItem._id);
                        data.append("devise_to_id", JSON.stringify(tab_devises_id));
                        data.append("user", this.$store.getters.auth._id);

                        let mineroute = 'exchanges/setExchange';
                        this.$store.dispatch(mineroute, data).then((response) => {
                            console.log('set exchanges response', response);
                            this.submitting = false;

                            if (response.data.error) {
                                this.toast('error',response.data.message)
                            } else {

                                this.toast('success',response.data.message)
                                $("#formLink")[0].reset();
                                this.closeLink();
                            }
                        })
                    }

                }


            },
            saveflag() {
                this.submitting = true;
                let data = new FormData();
                data.append("countries_choose", JSON.stringify(this.chooseFlagDev));
                data.append("devise_id", this.editedItem._id);
                console.log(this.chooseFlagDev);
                console.log(this.editedItem._id);
                let mineroute = 'devises/setDeviseCountries';
                this.$store.dispatch(mineroute, data).then((response) => {
                    this.submitting = false;

                    if (response.data.error) {
                        this.toast('error',response.data.message)
                    } else {

                        this.toast('success',response.data.message)
                        this.closeflag();

                    }
                })
            },
            save() {
                this.submitting = true;
                let data = new FormData();
                data.append("cod_num", this.editedItem._cod_num);
                data.append("name", this.editedItem._name);
                data.append("code_alpha", this.editedItem._code_alpha);
                let mineroute = 'devises/setDevise';
                if (this.editedIndex > -1) {
                    data.append("id", this.editedItem._id);
                    mineroute = 'devises/setUpdateDevise';
                }
                console.log("ELE");
                console.log(this.editedItem);
                this.$store.dispatch(mineroute, data).then((response) => {
                    this.submitting = false;

                    if (response.data.error) {
                        this.toast('error',response.data.message)
                    } else {

                        this.toast('success',response.data.message)
                        this.editedIndex = -1;
                        this.editedItem = Object.assign({}, this.defaulItem);
                        this.close();
                    }

                })
            },
            saveExcel() {
                this.submitting = true;
                let data = new FormData();
                data.append("file", this.editedItemExcel._file);
                data.append("user", this.$store.getters.auth._id);
                let mineroute = "";
                mineroute = 'devises/excelSetUpload';
                this.$store.dispatch(mineroute, data).then((response) => {
                    this.submitting = false;

                    if (response.data.error) {
                        this.toast('error',response.data.message)
                    } else {

                        this.toast('success',response.data.message)
                        this.closeexcel();
                    }

                })
            },
            validate() {
                this.$refs.form.validate()
            },
            reset() {
                this.$refs.form.reset()
            },
            checkisDashboard() {
                this.$emit('checkisDashboard', true);
            },
            fileChange() {
                console.log(this.$refs);
                this.editedItem._file = this.$refs.file.files[0];
            },
            getFileOriginalName(file) {
                return file.substr(file.lastIndexOf('/') + 1)
            },
            checkIfExist() {
                let VueBox = this;
                if (VueBox.editedIndex > -1) {
                    return VueBox.values.find(value => value._code === VueBox.editedItem.code && value._id !== VueBox.editedItem._id)
                } else {
                    return VueBox.values.find(value => value._code === VueBox.editedItem.code)
                }
            },
            selectedFile() {
                this.errors_excel = null;
                console.log('selected a file');
                let fileName = $("#input_file").val();

                let regex = new RegExp('[^.]+$');

                let extension = fileName.match(regex);
                console.log("extension",extension[0])
                let tab_ext = ["xls","xlsx"];
                if (!tab_ext.includes(extension[0])){
                    this.errors_excel = this.$t('devises.errors_excel');
                    this.validexcel = false;
                }else{
                    this.validexcel = true;
                }

            }
        }
        ,
        created() {
            this.checkisDashboard();
        }
    }
</script>

<style scoped>

</style>
